<template>
  <div id="overlay" @click="deleteMainDataCancel" >
    <div id="content" @click="stopPropagation" >
      <h1>Delete</h1>
      <div class="outline-vertical">
        <div class="block-vertical">
          <!-- val01 -->
          <div class="label-holder">
            {{ item.val01 }}
          </div>
          <!-- val02 -->
          <div class="label-holder">
            {{ item.val02 }}
          </div>
          <!-- val03 -->
          <div class="label-holder">
            {{ item.val03 }}
          </div>
          <!-- val04 -->
          <div class="label-holder" v-html="tagShaped(item.val04)"></div>
        </div>
        <div class="block-vertical">
          <div class="block-horizontal">
            <div class="button-holder">
              <button @click="deleteMainDataCancel" class="button-cancel" >cancel</button>
            </div>
            <div class="button-holder">
              <button @click="deleteMainDataFix(item.id)" class="button-attention" >delete!!</button>
            </div>
          </div>
        </div>
        <div class="block-vertical">
            <div class="div-procMsg-normal" v-if="procMsgNormal" >{{ procMsgNormal }}</div>
            <div class="div-procMsg-attention" v-if="procMsgAttention" >{{ procMsgAttention }}</div>
          </div>
      </div>
    </div>
  </div>
</template>

<script>
// 共通定数
import { MyConfig as mc } from '@/MyConfig'
// 認証モジュール
import { MyAuth } from '@/my-modules/my-auth'
// データモジュール
import { MyData } from '@/my-modules/my-data'

export default {
  name: 'ModalDelete',

  props: ['modalItem'],

  data: function () {
    return {
      item: '',
      idToken: '',
      procMsgNormal: null,
      procMsgAttention: null
    }
  },

  mounted: function () {
    this.item = this.modalItem
  },

  methods: {
    /* =================================================================================
     * stopPropagation
     *   モーダル背景のクリックイベントがdiv階層内に伝播しないようにする
     * ============================================================================== */
    stopPropagation () {
      event.stopPropagation()
    },

    /* =================================================================================
     * checkSession
     *   認証セッションの状態をチェック
     * ============================================================================== */
    async checkSession () {
      mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: Start', mc.LOG_TYPE_I) : (() => { })()
      try {
        const myAuth = new MyAuth()
        const res = await myAuth.checkSession()
        if (res.status === 'OK') {
          mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: OK', mc.LOG_TYPE_I) : (() => { })()
          this.idToken = res.content.idToken
          this.username = res.content.username
        } else if (res.status === 'NOAUTH') {
          mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: NOAUTH', mc.LOG_TYPE_I) : (() => { })()
          this.WriteProcMsg('normal', res.content)
        }
      // モジュールmyAuth(promise)からのrejectや例外エラーをcatch
      } catch (e) {
        mc.LOG_LEVEL ? console.log('%c error: Method=checkSession: e:', mc.LOG_TYPE_E, e) : (() => { })()
        this.WriteProcMsg('attention', 'Failed to check session at the moment, try back later.')
      }
      mc.LOG_LEVEL ? console.log('%c info: Method=checkSession: End', mc.LOG_TYPE_I) : (() => { })()
    },

    /* =================================================================================
     * tagShaped
     *   タグ表示用の装飾タグを付ける
     * ============================================================================== */
    tagShaped (val) {
      let _tagShaped = ''
      if (val) {
        for (const elem of val.split(',')) {
          if (elem) {
            _tagShaped = `${_tagShaped}<span class='tagShaped'>${elem}</span>`
          }
        }
      }
      return _tagShaped
    },

    /* =================================================================================
     * deleteMainDataCancel
     *   メインデータ削除処理を中止する
     * ============================================================================== */
    deleteMainDataCancel () {
      this.$emit('modalCanceled')
    },

    /* =================================================================================
     * deleteMainDataFix
     *   メインデータ削除処理を実行する
     * ============================================================================== */
    async deleteMainDataFix (targetId) {
      mc.LOG_LEVEL ? console.log('%c info: Method=deleteMainDataFix: Start', mc.LOG_TYPE_I) : (() => { })()
      this.resetProcMsg()
      try {
        // 認証セッションの状態をチェック
        await this.checkSession()
        if (!this.idToken) { return false }
        const myData = new MyData()
        const res = await myData.deleteMainData(this.idToken, targetId)
        if (res.status === 'OK') {
          // 画像データの削除も行う
          await this.deleteImageData(targetId)
          mc.LOG_LEVEL ? console.log('%c info: Method=deleteMainDataFix: OK', mc.LOG_TYPE_I) : (() => { })()
          this.$emit('modalFixed')
        }
      // モジュールmyData(async)からの例外エラーをcatch
      } catch (e) {
        mc.LOG_LEVEL ? console.log('%c error: Method=deleteMainDataFix: e:', mc.LOG_TYPE_E, e) : (() => { })()
        this.WriteProcMsg('attention', 'Failed to delete the data at the moment, try back later.')
      }
    },

    /* =================================================================================
     * deleteImageData
     *   画像データ削除処理を実行する
     * ============================================================================== */
    async deleteImageData (targetId) {
      mc.LOG_LEVEL ? console.log('%c info: Method=deleteImageData: Start', mc.LOG_TYPE_I) : (() => { })()
      try {
        const myData = new MyData()
        const res = await myData.deleteImageData(this.idToken, targetId)
        if (res.status === 'OK') {
          mc.LOG_LEVEL ? console.log('%c info: Method=deleteImageData: OK', mc.LOG_TYPE_I) : (() => { })()
          this.imageFile = ''
          this.WriteProcMsg('normal', 'Image data deleted.')
        }
      // モジュールmyData(async)からの例外エラーをcatch
      } catch (e) {
        mc.LOG_LEVEL ? console.log('%c error: Method=deleteImageData: e:', mc.LOG_TYPE_E, e) : (() => { })()
        this.imageFile = ''
        this.WriteProcMsg('attention', 'Failed to delete image data.')
      }
    },

    /* =================================================================================
     * WriteProcMsg
     *   メッセージ欄をブランクにする
     * ============================================================================== */
    WriteProcMsg (type, content) {
      if (type === 'normal') {
        this.procMsgNormal = content
        setTimeout(() => { this.procMsgNormal = null }, mc.MSG_TIMEOUT)
      } else if (type === 'attention') {
        this.procMsgAttention = content
        setTimeout(() => { this.procMsgAttention = null }, mc.MSG_TIMEOUT)
      }
    },

    /* =================================================================================
     * resetProcMsg
     *   メッセージ欄をブランクにする
     * ============================================================================== */
    resetProcMsg () {
      this.procMsgNormal = null
      this.procMsgAttention = null
    }
  }
}
</script>

<style scoped lang="scss">
#overlay{
  z-index: 51;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
}
#content{
  z-index: 52;
  max-width: 18em;
  width: 100%;
  padding: 0.5em;
  border-radius: 0.25em;
  box-shadow: 5px 5px 5px 1px rgba(0, 0, 0, 0.3);
  background:#fff;
}
.outline-vertical {
  display: flex;
  flex-direction: column;
}
.block-vertical {
  display: flex;
  flex-direction: column;
}
.block-horizontal {
  display: flex;
  flex-direction: row;
  justify-content: center;
}
.label-holder {
  min-height: 2em;
  line-height: 1.5em;
  margin: 0.25em 0;
  padding: 0.25em;
  background-color: #f2f2f2;
}
.button-holder {
  margin: 0.5em 0.1em 1em 0.1em;
}
</style>
